import React, { useCallback, useContext, useMemo } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { FlexMiddle, Tooltip as BaseTooltip } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled(FlexMiddle)`
  justify-content: center;
  position: relative;
  cursor: pointer;
  min-height: 70px;
  height: 60px;

  border-left: 1px solid ${({ theme }) => theme.colors.grey2};
`;

const BaseWrapper = styled(FlexMiddle)`
  justify-content: center;
  position: relative;
  cursor: pointer;
  min-height: 70px;
  height: 60px;
  background: repeating-linear-gradient(
    -45deg,
    rgba(232, 232, 232),
    rgba(232, 232, 232) 2px,
    rgba(232, 232, 232, 0.2) 2px,
    rgba(232, 232, 232, 0.2) 6px
  );

  border-left: 1px solid ${({ theme }) => theme.colors.grey2};
`;

const Tooltip = styled(BaseTooltip)`
  .rc-tooltip-inner {
    text-align: center;
  }
`;

const ShiftsWrapper = styled(FlexMiddle)`
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
  }
`;

const GeneralAvailabilityRenderer = ({ generalAvailabilityByDay, offset }) => {
  const { timeFormat } = useContext(ConfigContext);

  const { type, start, end, startBucketNum, endBucketNum } = generalAvailabilityByDay || {};

  const generalAvailabilityTitleFormat = useMemo(() => {
    switch (type) {
      case 'Partial':
        return `General: Available: ${moment(start).format(timeFormat)} - ${moment(end).format(timeFormat)}`;
      case 'Not Available':
        return `General : ${type}`;
      default:
        return null;
    }
  }, [end, start, timeFormat, type]);

  const isEmpty = useCallback((value) => value === 'undefined' || value === null, []);

  const wrapperStyle = useMemo(
    () =>
      !isEmpty(startBucketNum) && !isEmpty(endBucketNum)
        ? {
            gridColumnStart: startBucketNum - offset + 2,
            gridColumnEnd: endBucketNum - offset + 2,
            gridRowStart: 1,
            gridRowEnd: 1
          }
        : {},
    [endBucketNum, offset, isEmpty, startBucketNum]
  );

  if (!generalAvailabilityByDay || type === 'Available') {
    return '';
  }

  if (type === 'Partial') {
    const baseStyle = {
      gridArea: '1 / 2 / 1 / -1'
    };

    return (
      <>
        <BaseWrapper style={baseStyle}>
          <Tooltip placement="topLeft" body={generalAvailabilityTitleFormat}>
            <ShiftsWrapper />
          </Tooltip>
        </BaseWrapper>
        <Wrapper style={{ ...wrapperStyle, background: 'white' }}>
          <ShiftsWrapper />
        </Wrapper>
      </>
    );
  }

  return (
    <BaseWrapper style={wrapperStyle}>
      <Tooltip body={generalAvailabilityTitleFormat}>
        <ShiftsWrapper />
      </Tooltip>
    </BaseWrapper>
  );
};

export default React.memo(GeneralAvailabilityRenderer);
